import Loading from "../components/loading";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";
import Call from "../service/API";
import Mqtt from "../components/MQTT/";
import ProjectDashboard from "../components/ProjectDashboard";
const ProjectDashboardView = (props) => {
  const projectId = props.match.params.pId;
  const isLoading = useCustomState(true);
  const tableLoading = useCustomState(true);
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.projects);
  const counters = useSelector((state) => state.counters);
  const types = useSelector((state) => state.counterTypes);
  const tags = useSelector((state) => state.categories);
  const project = useCustomState(
    projects.filter(
      (project) => projectId === project.water_meter_project_id
    )[0]
  );
  const projectDevices = useCustomState(
    counters.filter(
      (counter) => projectId === counter?.water_meter_project_info?.project_id
    )
  );
  const counterTab = useCustomState("0");
  const sortValue = useCustomState("consumption_create_time");
  const counterReverseValue = useCustomState(true);
  const counterTableCount = useCustomState(20);
  const gasPage = useCustomState(1);
  const waterPage = useCustomState(1);
  const powerPage = useCustomState(1);
  const consumptions = useCustomState([]);
  const TabValue = useCustomState("0");
  const changeTab = (e, newValue) => {
    TabValue.handleChange(newValue);
  };
  const changeCounterTab = (e, newValue) => {
    tableLoading.handleChange(true);
    counterTab.handleChange(newValue);
    const tag = renderTag(newValue);
    const page = renderPage(newValue);
    fetchConsumptions(
      consumptions,
      projectId,
      tag,
      page,
      sortValue.value,
      counterReverseValue.value,
      counterTableCount.value,
      tableLoading
    );
  };
  const changePageFunc = (page) => {
    tableLoading.handleChange(true);
    const tag = renderTag(counterTab.value);
    if (counterTab.value === "0") {
      waterPage.handleChange(page);
    } else if (counterTab.value === "1") {
      powerPage.handleChange(page);
    } else {
      gasPage.handleChange(page);
    }
    fetchConsumptions(
      consumptions,
      projectId,
      tag,
      page,
      sortValue.value,
      counterReverseValue.value,
      counterTableCount.value,
      tableLoading
    );
  };
  const renderTag = (tag) => {
    switch (tag) {
      case "0":
        return tags.filter((tag) => tag.name === "آب")[0].id;
      case "1":
        return tags.filter((tag) => tag.name === "برق")[0].id;

      case "2":
        return tags.filter((tag) => tag.name === "گاز")[0].id;

      default:
        return tags.filter((tag) => tag.name === "آب")[0].id;
    }
  };
  const renderPage = (tabCounter) => {
    switch (tabCounter) {
      case "0":
        return waterPage.value;
      case "1":
        return powerPage.value;

      case "2":
        return gasPage.value;

      default:
        return waterPage.value;
    }
  };
  const updateConsumptions = () => {
    tableLoading.handleChange(true);
    const tag = renderTag(counterTab.value);
    const page = renderPage(counterTab.value);
    fetchConsumptions(
      consumptions,
      projectId,
      tag,
      page,
      sortValue.value,
      counterReverseValue.value,
      counterTableCount.value,
      tableLoading
    );
  };
  useEffect(() => {
    const navigations = [
      { name: "مدیریت پروژه ها", path: "/admin/projects" },
      { name: "جزئیات پروژه", path: "#", id: projectId },
    ];
    dispatch(UpdateNavigations(navigations));
    if (
      window.localStorage.getItem("dashHistory") &&
      JSON.parse(window.localStorage.getItem("dashHistory")).id === projectId
    ) {
      let history = JSON.parse(window.localStorage.getItem("dashHistory"));
      TabValue.handleChange(history.projectTab);
      counterTab.handleChange(history.counterTab);
      sortValue.handleChange(history.filters.sortValue);
      counterReverseValue.handleChange(history.filters.reverseValue);
      counterTableCount.handleChange(history.filters.count);
      gasPage.handleChange(history.pages.gas);
      waterPage.handleChange(history.pages.water);
      powerPage.handleChange(history.pages.power);
      consumptions.handleChange(history.data);
      tableLoading.handleChange(false);
    } else {
      fetchConsumptions(
        consumptions,
        projectId,
        renderTag(counterTab.value),
        1,
        sortValue.value,
        counterReverseValue.value,
        counterTableCount.value,
        tableLoading
      );
    }
    isLoading.handleChange(false);
  }, []);

  return (
    <>
      {isLoading.value ? (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <Loading />
        </div>
      ) : (
        <>
          <ProjectDashboard
            TabValue={TabValue.value}
            changeTab={changeTab}
            projectId={projectId}
            project={project}
            devices={projectDevices}
            tags={tags}
            types={types}
            sortValue={sortValue}
            reverseValue={counterReverseValue}
            counterTab={counterTab}
            changeCounterTab={changeCounterTab}
            gasPage={gasPage}
            powerPage={powerPage}
            waterPage={waterPage}
            count={counterTableCount}
            updateCounterTable={updateConsumptions}
            changeCounterPage={changePageFunc}
            consumptions={consumptions.value}
            tableLoading={tableLoading}
          />
          <Mqtt projectId={projectId} update={() => updateConsumptions()} />
        </>
      )}
    </>
  );
};
export default ProjectDashboardView;
const fetchConsumptions = (
  consumption,
  projectId,
  tag,
  page,
  sortValue,
  reverse,
  count,
  tableLoading
) => {
  const data = {
    page: page,
    count: count,
    user_id: null,
    project_id: projectId,
    water_meter_serial: null,
    water_meter_tag: tag,
    sort_value: sortValue,
    reverse: reverse,
  };
  Call("POST", "watermeters/admin/cumulative/consumption", data)
    .then((response) => {
      if (response.data.code === 200) {
        consumption.handleChange(response.data.data);
        tableLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
        console.log(error.response);
      }
    });
};
